import React, { useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  AppBar,
  Button,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Switch,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import DividerWithText from '../../DividerWithText/DividerWithText';
import Autocomplete from '@material-ui/lab/Autocomplete';
import styles from '../constants/styles';
import {
  createNewEquipment,
  getEquipmentHoldingProfile,
} from '../../../redux/actions/equipmentsActions';
import { snackbarShowMessage } from '../../../redux/actions/snackbarActions';
import VerticalTabsEquipmentAssigned from '../../EditEquipmentModal/VerticalTabsEquipmentAssigned';
import { ShowHoldingProfileEquipment } from '../../EditEquipmentModal/ShowHoldingProfileEquipment';
import { TabPanel } from '../../ProfilesTabs/TabPanel';

import {
  EquipmentAvailabilitySelector,
  ParseRequestAvailabilities as ParseAvailabilityPayload,
} from './../../EditEquipmentModal/EquipmentAvailabilitySelector';
import {
  EquipmentFranchiseGroupsSelector,
  ParseRequestAvailabilities as ParseFranchiseGroupsAvailabilityPayload,
} from './../../EditEquipmentModal/EquipmentFranchiseGroupsSelector';
import RBIAutocompleteSearch from '../../RBIAutocompleteSearch/RBIAutocompleteSearch';
import { useTranslation } from 'react-i18next';

const CreateModel = ({ handleClose, handleRefreshOnCreate }) => {
  const classes = styles();
  const dispatch: any = useDispatch();
  const selectedBrand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );
  const approvalTypes = useSelector(
    (state: RootStateOrAny) => state.ApprovalTypesReducer.entities,
  );
  const categories = useSelector(
    (state: RootStateOrAny) => state.CategoriesReducer.entitiesCatalog,
  );
  const manufacturers = useSelector(
    (state: RootStateOrAny) => state.ManufacturersReducer.entitiesCatalog,
  );
  const cProfiles = useSelector(
    (state: RootStateOrAny) => state.CalibrationProfilesReducer.entities,
  );

  const [searchObjectPrev, setSearchObjectPrev] = useState<any>({
    availability: '',
    category: '',
    supplier: '',
    description: '',
    model: '',
    manufacturer: '',
    profiles: [],
    is_core: false,
    requires_training: false,
    is_visible_for_franchise: false,
    is_active: false,
    type: '',
  });

  const [tabValue, setTabValue] = React.useState(0);

  const onSelectOption = (name: string, value = {}) => {
    setSearchObjectPrev({
      ...searchObjectPrev,
      [name]: value,
    });
  };
  const [timer, setTimer] = useState<any>(null);

  const handleChangeTextfield = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setSearchObjectPrev({
      ...searchObjectPrev,
      [event.target.name]: event.target.value,
    });
  };

  const onTagsChange = (event, values) => {
    setSearchObjectPrev({
      ...searchObjectPrev,
      profiles: values,
    });
  };

  const handleChangeSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchObjectPrev({
      ...searchObjectPrev,
      [event.target.name]: event.target.checked,
    });
  };

  const handleChangeSwitchCalibration = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setSearchObjectPrev({
      ...searchObjectPrev,
      calibration: event.target.checked,
      profiles: [],
    });
  };
  const holdingProfilesToAdd = useSelector(
    (state: RootStateOrAny) => state.EquipmentsReducer.equipmentHoldingProfiles,
  );
  const [profilesSelected, setProfilesSelected] = useState<any[]>([]);

  //#region Equipment Availability

  const [availabilityAllowance, setAvailabilityAllowance] = useState<any[]>([]);
  const [availabilityExclusions, setAvailabilityExclusions] = useState<any[]>(
    [],
  );
  const [availabilityFranchiseGroups, setAvailabilityFranchiseGroups] =
    useState<any[]>([]);

  const handleAvailabilityAllowanceChange = (value: any[]) => {
    setAvailabilityAllowance(value);
  };

  const handleAvailabilityExclusionsChange = (value: any[]) => {
    setAvailabilityExclusions(value);
  };

  const handleFranchiseGroupsChange = (value: any[]) => {
    setAvailabilityFranchiseGroups(value);
  };

  ////#endregion Equipment Availability
  /*
    useEffect(() => {
      dispatch(
        getEquipmentHoldingProfiles({
          brand: selectedBrand,
          page: 1,
          limit: 100,
          category: searchObjectPrev.category?.id || '',
          manufacturer_id: searchObjectPrev.manufacturer?.id || '',
        }),
      );

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
      selectedBrand,
      searchObjectPrev.category,
      searchObjectPrev.manufacturer,
    ]);
    */
  const saveEquipment = async () => {
    const newEquipment = {
      brand_id: selectedBrand,
      category_id: searchObjectPrev['category'].id,
      approval_type_id: searchObjectPrev['type'],
      is_core: searchObjectPrev['is_core'],
      requires_training: searchObjectPrev['requires_training'],
      description: searchObjectPrev['description'],
      is_visible_for_franchise: searchObjectPrev['is_visible_for_franchise'],
      is_active: true,
      model: searchObjectPrev['model'],
      manufacturer_id: searchObjectPrev['manufacturer'].id,
      included_availability: ParseAvailabilityPayload(availabilityAllowance),
      ...(availabilityExclusions.length > 0 && {
        excluded_availability: ParseAvailabilityPayload(availabilityExclusions),
      }),
      ...(availabilityFranchiseGroups.length > 0 && {
        included_franchise_groups: ParseFranchiseGroupsAvailabilityPayload(
          availabilityFranchiseGroups,
        ),
      }),
      calibration_profile: searchObjectPrev['profiles'].map(p => p.id),
      holding_profiles_allocations: profilesSelected.map(profile => profile.id),
    };
    if (!searchObjectPrev['type']) delete newEquipment.approval_type_id;
    if (selectedBrand !== 'TH' || !searchObjectPrev['calibration'])
      delete newEquipment.calibration_profile;
    const response: any = await dispatch(
      createNewEquipment({
        ...newEquipment,
      }),
    );
    if (response?.status === 200) {
      dispatch(snackbarShowMessage('equipment.model.createSuccess'));
    }
    handleRefreshOnCreate();
    handleClose();
  };

  const [holdingProfilesSelected, setHoldingProfilesSelected] = useState([]);
  const onChangeMultiple = async (event, values) => {
    setHoldingProfilesSelected(values);
    const missingProfiles = values.filter(
      value =>
        !profilesSelected.find((profile: any) => profile.id === value.id),
    );
    const result: any = await Promise.all(
      missingProfiles.map(
        async profile =>
          await dispatch(getEquipmentHoldingProfile('', profile.id)),
      ),
    );
    setProfilesSelected([
      ...profilesSelected.map((p: any) => p),
      ...result.map((r: any) => r.data.holdingProfile),
    ]);
  };
  const handleRemove = (index, id) => () => {
    const newCopyProfiles = profilesSelected.filter((p, i) => i !== index);
    const newCopySelected = holdingProfilesSelected.filter(
      (p: any) => p.id !== id,
    );
    setProfilesSelected([...newCopyProfiles]);
    setHoldingProfilesSelected([...newCopySelected]);
  };

  const handleChangeSelect = event => {
    setSearchObjectPrev({
      ...searchObjectPrev,
      [event.target.name]: event.target.value ? event.target.value : '',
    });
  };

  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <div className={classes.divItems}>
              <RBIAutocompleteSearch
                onChange={onSelectOption}
                value={searchObjectPrev['category']}
                id="category"
                label={t('createModel.category')}
                options={categories.filter(category => category.is_active)}
                width={'100%'}
              />
              <RBIAutocompleteSearch
                onChange={onSelectOption}
                value={searchObjectPrev['manufacturer']}
                id="manufacturer"
                label={t('createModel.manufacturer')}
                options={manufacturers.filter(
                  manufacturer => manufacturer.status,
                )}
                width={'100%'}
              />
            </div>
            <div className={classes.divItems}>
              <TextField
                style={{ width: '100%', marginTop: 8 }}
                size="small"
                onChange={handleChangeTextfield}
                value={searchObjectPrev['model']}
                name="model"
                variant="outlined"
                label={t('createModel.newModel')}
              />
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                style={{ marginTop: 8 }}
              >
                <InputLabel id="demo-simple-select-outlined-label">
                  {t('createModel.approvalType')}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  name="type"
                  label={t('createModel.approvalType')}
                  fullWidth
                  onChange={handleChangeSelect}
                  value={searchObjectPrev['type']}
                >
                  {approvalTypes.map(type => (
                    <MenuItem key={type.id} value={type.id}>
                      {type.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div>
              <TextField
                fullWidth
                size="small"
                style={{ marginTop: 15 }}
                variant="outlined"
                label={t('createModel.description')}
                onChange={handleChangeTextfield}
                value={searchObjectPrev['description']}
                name="description"
              />
            </div>
            <div>
              <FormControl component="fieldset">
                <FormGroup aria-label="position" row>
                  <FormControlLabel
                    value="start"
                    control={
                      <Switch
                        checked={searchObjectPrev['is_core']}
                        onChange={handleChangeSwitch}
                        name="is_core"
                        color="primary"
                      />
                    }
                    label={t('equipment.core')}
                    labelPlacement="start"
                  />
                  <FormControlLabel
                    value="start"
                    control={
                      <Switch
                        checked={searchObjectPrev['is_visible_for_franchise']}
                        onChange={handleChangeSwitch}
                        name="is_visible_for_franchise"
                        color="primary"
                      />
                    }
                    label={t('createModel.franchiseVisible')}
                    labelPlacement="start"
                  />
                  <FormControlLabel
                    value="start"
                    control={
                      <Switch
                        checked={searchObjectPrev['requires_training']}
                        onChange={handleChangeSwitch}
                        name="requires_training"
                        color="primary"
                      />
                    }
                    label={t('equipment.training')}
                    labelPlacement="start"
                  />
                  {selectedBrand === 'TH' && (
                    <FormControlLabel
                      value="start"
                      control={
                        <Switch
                          checked={searchObjectPrev['calibration']}
                          onChange={handleChangeSwitchCalibration}
                          name="calibration"
                          color="primary"
                        />
                      }
                      label={t('createModel.calibrationCheck')}
                      labelPlacement="start"
                    />
                  )}
                </FormGroup>
              </FormControl>
            </div>
            {searchObjectPrev['calibration'] && (
              <div>
                <Autocomplete
                  multiple
                  id="tags-outlined"
                  options={cProfiles}
                  onChange={onTagsChange}
                  getOptionLabel={(profile: any) => profile.name || ''}
                  filterSelectedOptions
                  noOptionsText={t`app.common.noOptions`}
                  renderInput={params => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label={t('equipment.editEquipment.calibrationProfiles')}
                      placeholder="Select Profiles"
                    />
                  )}
                />
              </div>
            )}
            <div style={{ marginTop: 15 }}>
              <EquipmentAvailabilitySelector
                allowance={availabilityAllowance}
                exclusions={availabilityExclusions}
                hasExclusions={true}
                onAllowanceChange={handleAvailabilityAllowanceChange}
                onExclusionsChange={handleAvailabilityExclusionsChange}
                spacing={0}
              />
            </div>
            <div style={{ marginTop: 15, marginBottom: 15 }}>
              <EquipmentFranchiseGroupsSelector
                id="franchise-groups-availability-input"
                label={t('createModel.franchiseGroups')}
                brand={selectedBrand}
                value={availabilityFranchiseGroups}
                onChange={handleFranchiseGroupsChange}
              />
            </div>
          </Grid>
          <Grid item xs={6}>
            <AppBar position="static" className={classes.appBar}>
              <Toolbar variant="dense">
                <Typography>
                  {t('createModel.descriptionTranslations')} (0)
                </Typography>
              </Toolbar>
            </AppBar>
            <Paper className={classes.paper}>
              <DividerWithText mt={10}>English</DividerWithText>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <AppBar position="static" className={classes.appBar}>
          <Toolbar variant="dense" className={classes.flexSpaceBetween}>
            <Typography>{t('createModel.holdingProfiles')}</Typography>
            <Autocomplete
              multiple
              style={{ minWidth: '350px' }}
              id="tags-outlined"
              options={holdingProfilesToAdd.holdingProfiles || []}
              value={holdingProfilesSelected}
              noOptionsText={t`app.common.noOptions`}
              filterSelectedOptions
              onChange={onChangeMultiple}
              getOptionLabel={(p: any) =>
                `(${p.category.name},${p.manufacturer.name})${p.availabilities[0]?.region}`
              }
              disabled
              // filterSelectedOptions
              size="small"
              renderInput={params => (
                <TextField
                  {...params}
                  variant="outlined"
                  label={t('equipment.addFromCatalog')}
                  placeholder={t('equipment.addFromCatalog')}
                  size="small"
                />
              )}
            />
          </Toolbar>
        </AppBar>
        <Paper className={`${classes.paper} ${classes.holdingProfilesTabs}`}>
          <VerticalTabsEquipmentAssigned
            profiles={profilesSelected}
            value={tabValue}
            setValue={setTabValue}
            defaultName={t('createModel.holdingProfiles')}
          />
          {profilesSelected.map((profile, index) => (
            <TabPanel value={tabValue} index={index}>
              <ShowHoldingProfileEquipment
                title="Product Profile Availability"
                holdingProfile={profile}
                handleRemove={handleRemove}
                index={index}
              />
            </TabPanel>
          ))}
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <div className={classes.divItems}>
          <div>
            <Button disabled variant="outlined" color="primary">
              {t('createModel.saveAndCreateHoldingProfile')}
            </Button>
          </div>
          <div className={classes.divFilters}>
            <Button variant="outlined" color="primary" onClick={handleClose}>
              {t('app.common.cancel')}
            </Button>
            <Button
              disabled={
                !searchObjectPrev['category'] ||
                !searchObjectPrev['manufacturer'] ||
                !searchObjectPrev['description'] ||
                !searchObjectPrev['model'] ||
                !searchObjectPrev['type'] ||
                availabilityAllowance.length === 0 ||
                (selectedBrand === 'TH' &&
                  searchObjectPrev['calibration'] &&
                  !searchObjectPrev['profiles'].length)
              }
              variant="contained"
              color="primary"
              onClick={saveEquipment}
            >
              {t('app.common.save')}
            </Button>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default CreateModel;
